import serviceAxios from '../index'
// get 请求需要传 params，post 请求需要传 data
// 获取公司
export const SerchInfo = (data) => {
  return serviceAxios({
    url: '/index.php/Certification/get_company',
    method: 'post',
    data
  })
}
// 查看证书
export const chakanCompany = (data) => {
  return serviceAxios({
    url: '/index.php/Certification/get_company_desc',
    method: 'post',
    data
  })
}
// 扫码查看
export const zhengshuChaKan = (data) => {
  return serviceAxios({
    url: '/index.php/Certification/get_company_rand',
    method: 'post',
    data
  })
}
